import { useContext } from "react";
import { notification } from "antd";
import { deleteRequest, getRequest, handleResponse, patchFormRequest, patchFormRequests, patchRequest, postFormRequest, postFormRequests, putFormRequest } from "../../context/requestTypes";
import { AxiosContext } from "../../context/AxiosContext";
import { useMutation, useQuery } from "react-query";
import { useRecoilValue } from "recoil";
import authAtom from "../../atoms/auth/auth.atom";



export function useGetProducts(params, key) {
  const url = "/Product/GetProducts";
  const axios = useContext(AxiosContext);
  return useQuery(["key:get_all_Products", ...(key||[])?.map(d => params?.[d])], () => getRequest(axios, url, params), {
    onSuccess: (response) => handleResponse(response),
    onError: (error) => notification.error({
      message: "Error!",
      description: error?.message ? (Object.entries(error?.errors || {key:[error?.message]})?.map(([,value]) => value?.join(", ")))?.join(", ") : "something went wrong please check internet connection.",
    }),
  });
}

export function useGetProduct(successAction) {
  const url = "/Product/GetProduct/";
  const axios = useContext(AxiosContext);
  return useMutation((id) => getRequest(axios, url+id), {
    onSuccess: (response) => handleResponse(response, () => successAction?.()),
    onError: (error) => notification.error({
      message: "Error!",
      description: error?.message ? (Object.entries(error?.errors || {key:[error?.message]})?.map(([,value]) => value?.join(", ")))?.join(", ") : "something went wrong please check internet connection.",
    }),
  });
}

export function usePostProduct(successAction) {
  const url = "/Product/CreateProduct";
  const { user } = useRecoilValue(authAtom)
  return useMutation((payload) => postFormRequests(url, payload, user?.token), {
    onSuccess: (response) => {
      handleResponse(response, () => {
        successAction?.()
        notification.success({
          message: "Success!",
          description: response?.message || "action successful",
        })
      })
    },
    onError: (error) => notification.error({
      message: "Error!",
      description: error?.message ? (Object.entries(error?.errors || {key:[error?.message]})?.map(([,value]) => value?.join(", ")))?.join(", ") : "something went wrong please check internet connection.",
    }),
  });
}

export function usePutProduct(successAction) {
  const url = "/Product/EditProduct/";
  const { user } = useRecoilValue(authAtom)
  return useMutation((payload) => putFormRequest(url+payload?.id, payload, user?.token), {
    onSuccess: (response) => {
      handleResponse(response, () => {
        successAction?.()
        notification.success({
          message: "Success!",
          description: response?.message || "action successful",
        })
      })
    },
    onError: (error) => notification.error({
      message: "Error!",
      description: error?.message ? (Object.entries(error?.errors || {key:[error?.message]})?.map(([,value]) => value?.join(", ")))?.join(", ") : "something went wrong please check internet connection.",
    }),
  });
}

export function useDeleteProduct(successAction) {
  const url = `/Product/DeleteProduct/`;
  const axios = useContext(AxiosContext);
  return useMutation((id) => deleteRequest(axios, url+id), {
    onSuccess: (response) => {
      handleResponse(response, () => {
        successAction?.()
        notification.success({
          message: "Success!",
          description: response?.message || "action successful",
        })
      })
    },
    onError: (error) => notification.error({
      message: "Error!",
      description: error?.message ? (Object.entries(error?.errors || {key:[error?.message]})?.map(([,value]) => value?.join(", ")))?.join(", ") : "something went wrong please check internet connection.",
    }),
  });
}

export function usePatchProduct(successAction) {
  const url = "/Product/EditProduct/"; 
  const { user } = useRecoilValue(authAtom)
  return useMutation((payload) => patchFormRequests(url+payload?.id, payload, user?.token), {
    onSuccess: (response) => {
      handleResponse(response, () => {
        successAction?.()
        notification.success({
          message: "Success!",
          description: response?.message || "action successful",
        })
      })
    },
    onError: (error) => notification.error({
      message: "Error!",
      description: error?.message ? (Object.entries(error?.errors || {key:[error?.message]})?.map(([,value]) => value?.join(", ")))?.join(", ") : "something went wrong please check internet connection.",
    }),
  });
}
